<template>
  <div>
    <section class="section-hero section-shaped my-0">
      <div class="shape shape-style-1 shape-default">
        <span class="span-150"></span>
        <span class="span-50"></span>
        <span class="span-50"></span>
        <span class="span-75"></span>
        <span class="span-100"></span>
        <span class="span-75"></span>
        <span class="span-50"></span>
        <span class="span-100"></span>
        <span class="span-50"></span>
        <span class="span-100"></span>
      </div>
      <div class="container shape-container d-flex align-items-center ">
        <div class="col px-0">
          <div class="row justify-content-center align-items-center">
            <div class="col-lg-8 text-center pt-lg">
              <img
                src="img/brand/logo-dark.png"
                style="width: 300px; margin-bottom:30px"
                class="img-fluid"
              />

              <h1 class="display-3  text-white">
                Get the dedicated expertise your company needs, today!
              </h1>
              <p class="lead  text-white">
                Universal Tech is a one-stop multi-vendor focused on providing
                quality data center hardware, equipment, solutions, and
                services.
              </p>
              <div class="btn-wrapper mb-5 p-2">
                <router-link
                  style="margin-right:10px;color:white;"
                  to="/company"
                >
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    icon="fa fa-lightbulb-o"
                  >
                    Learn More
                  </base-button>
                </router-link>
                <router-link to="/contact">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="white"
                    icon="fa fa-phone"
                  >
                    Get in Touch
                  </base-button>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!--
    <div class="position-relative">

      <section class="section-shaped my-0">
        <div class="shape shape-style-1 shape-default shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-8">
                <h1 class="display-3  text-white">
                  Get the dedicated expertise your company needs, today!
                </h1>
                <p class="lead  text-white">
                  Universal Tech is a one-stop multi-vendor focused on providing
                  quality data center hardware, equipment, solutions, and
                  services.
                </p>
                <div class="btn-wrapper">
                  <router-link
                    style="margin-right:10px;color:white;"
                    to="/company"
                  >
                    <base-button
                      tag="a"
                      class="mb-3 mb-sm-0"
                      type="info"
                      icon="fa fa-lightbulb-o"
                    >
                      Learn More
                    </base-button>
                  </router-link>
                  <router-link to="/contact">
                    <base-button
                      tag="a"
                      class="mb-3 mb-sm-0"
                      type="white"
                      icon="fa fa-phone"
                    >
                      Get in Touch
                    </base-button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </div> -->
    <section class="section section-lg pt-lg-0 ">
      <div class="container">
        <div class="row justify-content-center">
          <p class="display-1 p-2 mt-4 ">Solutions</p>
          <p class="lead p-2 text-center">
            We actively operates in the IT and data center industry, providing
            services with a differentiating touch and uniqueness.
          </p>
          <div class="col-lg-12 mx-auto">
            <div class="row row-grid">
              <div class="col-lg-4">
                <card
                  class="border-0 center_card"
                  hover
                  shadow
                  body-classes="py-5"
                >
                  <icon
                    name="fa fa-building text-center"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">
                    Digital Infrastructure
                  </h6>
                  <p class="description mt-3">
                    We help organizations of all sizes with building a robust
                    digital infrastructure and developing a broad-based digital
                    workforce.
                  </p>
                  <div>
                    <router-link
                      to="/solutions/digitalinfrastructure"
                      class="pr-1"
                      ><badge type="primary" rounded
                        >Data centers</badge
                      ></router-link
                    >
                    <router-link
                      to="/solutions/digitalinfrastructure/collaboration"
                      class="pr-1"
                    >
                      <badge type="primary" rounded
                        >Collaboration</badge
                      ></router-link
                    >
                    <router-link
                      to="/solutions/digitalinfrastructure/networking"
                      class="pr-1"
                    >
                      <badge type="primary" rounded
                        >Networking</badge
                      ></router-link
                    >
                    <router-link
                      to="/solutions/digitalinfrastructure/analytics"
                      class="pr-1"
                    >
                      <badge type="primary" rounded
                        >Analytics</badge
                      ></router-link
                    >
                  </div>
                  <router-link to="/solutions/digitalinfrastructure">
                    <base-button tag="a" href="#" type="primary" class="mt-4">
                      Learn more
                    </base-button></router-link
                  >
                </card>
              </div>
              <div class="col-lg-4">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-lock" type="warning" rounded class="mb-4">
                  </icon>
                  <h6 class="text-warning text-uppercase">Security</h6>
                  <p class="description mt-3">
                    Developing a security approach that provides 360-degree
                    protection is key and Important.
                  </p>
                  <div>
                    <router-link to="/solutions/digitalsecurity" class="pr-1">
                      <badge type="warning" rounded>Digital Security</badge>
                    </router-link>
                    <router-link to="/solutions/digitalsecurity" class="pr-1">
                      <badge type="warning" rounded>Access Control</badge>
                    </router-link>
                    <router-link to="/solutions/digitalsecurity" class="pr-1">
                      <badge type="warning" rounded
                        >Identity and authentication</badge
                      >
                    </router-link>
                  </div>
                  <router-link to="/solutions/digitalsecurity">
                    <base-button tag="a" href="#" type="warning" class="mt-4">
                      Learn more
                    </base-button></router-link
                  >
                </card>
              </div>
              <div class="col-lg-4 ">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cloud" type="info" rounded class="mb-4">
                  </icon>
                  <h6 class="text-info text-uppercase">Cloud</h6>
                  <p class="description mt-3">
                    Transform from cost generating centers into strategic
                    service providers and business enablers with our cloud
                    offerings.
                  </p>
                  <div>
                    <router-link
                      to="/solutions/cloud/datacentermodernization"
                      class="pr-1"
                    >
                      <badge type="info" rounded
                        >Data Center Modernization</badge
                      ></router-link
                    >
                    <router-link
                      to="/solutions/cloud/hybridclouds"
                      class="pr-1"
                    >
                      <badge type="info" rounded
                        >Hybrid Clouds</badge
                      ></router-link
                    >
                    <router-link to="/solutions/cloud/devops" class="pr-1">
                      <badge type="info" rounded>DevOps</badge></router-link
                    >
                  </div>
                  <router-link to="/solutions/cloud/">
                    <base-button tag="a" href="#" type="info" class="mt-4">
                      Learn more
                    </base-button></router-link
                  >
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section bg-secondary">
      <div class="container">
        <div class="row row-grid align-items-center">
          <div class="col-md-6">
            <div class="card bg-default shadow border-0">
              <img v-lazy="'img/theme/ban1.png'" class="card-img-top" />
              <blockquote class="card-blockquote">
                <svg
                  preserveAspectRatio="none"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 583 95"
                  class="svg-bg"
                >
                  <polygon
                    points="0,52 583,95 0,95"
                    class="fill-default"
                  ></polygon>
                  <polygon
                    points="0,42 583,95 683,0 0,95"
                    opacity=".2"
                    class="fill-default"
                  ></polygon>
                </svg>
                <h4 class="display-3 font-weight-bold text-white">
                  Why Universal Tech?
                </h4>
                <p class="lead text-italic text-white">
                  Our expertise, resources, and attention to detail make us
                  stand out and the ideal choice to meet the client’s needs for
                  an infrastructure and security solution.
                </p>
              </blockquote>
            </div>
          </div>
          <div class="col-md-6">
            <div class="pl-md-5">
              <h3>We help our customers succceed</h3>
              <p class="lead">
                Our customers want to excel in every aspect of its business,
                which means it will need to take advantage of the best
                technological tools available in order to gain an edge over its
                competitors. This is the reason you want a company like
                Universal Tech LLC to provide you with a customized solution to
                maximize efficiency and security, minimize cost, and achieve
                your unique goals.
              </p>
              <a href="#" class="font-weight-bold text-warning mt-5"></a>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-1 bg-gradient-warning shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container py-0">
        <div class="row row-grid align-items-center">
          <div class="col-md-6 order-lg-2 ml-lg-auto">
            <div class="position-relative pl-md-5">
              <img src="img/ill/ill-2.svg" class="img-center img-fluid" />
            </div>
          </div>
          <div class="col-lg-6 order-lg-1">
            <div class="d-flex px-3">
              <div>
                <icon
                  name="ni ni-building"
                  size="lg"
                  class="bg-gradient-white"
                  color="primary"
                  shadow
                  rounded
                ></icon>
              </div>
              <div class="pl-4">
                <h4 class="display-3 text-white">Services</h4>
                <!--   <p class="text-white">The Arctic Ocean freezes every winter and much of the sea-ice then
                                    thaws every summer, and that process will continue whatever happens.</p> -->
              </div>
            </div>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="ni ni-atom"
                    gradient="warning"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-warning">Lifecycle Management</h5>
                  <p>
                    Automation, simplicity and intelligence to track all your
                    assets.
                  </p>
                  <router-link
                    to="/services/lifecyclemanagement"
                    class="text-warning"
                    >Learn more</router-link
                  >
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="fa fa-server"
                    gradient="primary"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-primary">
                    Asset Management and Support
                  </h5>
                  <p>
                    Asset Management offering is added to every maintenance
                    engagement, eliminating the need for internal resources
                    allocated for contract management.
                  </p>
                  <router-link
                    to="/services/assetmanagementandsupport"
                    class="text-primary"
                    >Learn more</router-link
                  >
                </div>
              </div>
            </card>
            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="fa fa-link"
                    gradient="danger"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-danger">
                    Integration and Implementation
                  </h5>
                  <p>
                    We offer services on integration and implementation of
                    infrastructure.
                  </p>
                  <router-link
                    to="/services/integrationandimplementation"
                    class="text-danger"
                    >Learn more</router-link
                  >
                </div>
              </div>
            </card>

            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="fa fa-bell"
                    gradient="info"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-info">Managed Services</h5>
                  <p>
                    Our managed services address daily IT management needs,
                    enabling your internal IT staff to better focus on strategic
                    initiatives.
                  </p>
                  <router-link
                    to="/services/integrationandimplementation"
                    class="text-info"
                    >Learn more</router-link
                  >
                </div>
              </div>
            </card>

            <card shadow class="shadow-lg--hover mt-5">
              <div class="d-flex px-3">
                <div>
                  <icon
                    name="fa fa-bus"
                    gradient="success"
                    color="white"
                    shadow
                    rounded
                  ></icon>
                </div>
                <div class="pl-4">
                  <h5 class="title text-success">Relocation Services</h5>
                  <p>
                    You can depend on our expertise and professionals to plan
                    and execute every relocation project.
                  </p>
                  <router-link
                    to="/services/relocationservices"
                    class="text-success"
                    >Learn more</router-link
                  >
                </div>
              </div>
            </card>
          </div>
        </div>
      </div>
    </section>

    <!--
    <section class="section section-lg pt-0">
      <div class="container">
        <card gradient="warning" no-body shadow-size="lg" class="border-0">
          <div class="p-5">
            <div class="row align-items-center">
              <div class="col-lg-8">
                <h3 class="text-white">We help startups get up to speed.</h3>
                <p class="lead text-white mt-3">
                  Universal tech can help startups in with their digital
                  strategy.
                </p>
              </div>
              <div class="col-lg-3 ml-lg-auto">
                <base-button tag="a" href="#" type="white" block size="lg">
                  Learn more.
                </base-button>
              </div>
            </div>
          </div>
        </card>
      </div>
    </section> -->
    <!-- <section class="section section-shaped my-0 overflow-hidden">
      <div class="shape shape-style-3 bg-gradient-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container pt-lg pb-300">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3 text-white">Build something</h2>
            <p class="lead text-white">
              According to the National Oceanic and Atmospheric Administration,
              Ted, Scambos, NSIDClead scentist, puts the potentially record low
              maximum sea ice extent tihs year down to low ice.
            </p>
          </div>
        </div>
        <div class="row row-grid mt-5">
          <div class="col-lg-4">
            <icon
              name="ni ni-settings"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Building tools</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-ruler-pencil"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Grow your market</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
          <div class="col-lg-4">
            <icon
              name="ni ni-atom"
              size="lg"
              gradient="white"
              shadow
              round
              color="primary"
            ></icon>
            <h5 class="text-white mt-3">Launch time</h5>
            <p class="text-white mt-3">
              Some quick example text to build on the card title and make up the
              bulk of the card's content.
            </p>
          </div>
        </div>
      </div>
    </section> -->
    <!-- <section class="section section-lg pt-lg-0 section-contact-us">
      <div class="container">
        <div class="row justify-content-center mt--300">
          <div class="col-lg-8">
            <card gradient="secondary" shadow body-classes="p-lg-5">
              <h4 class="mb-1">Want to work with us?</h4>
              <p class="mt-0">Your project is very important to us.</p>
              <base-input
                class="mt-5"
                alternative
                placeholder="Your name"
                addon-left-icon="ni ni-user-run"
              >
              </base-input>
              <base-input
                alternative
                placeholder="Email address"
                addon-left-icon="ni ni-email-83"
              >
              </base-input>
              <base-input class="mb-4">
                <textarea
                  class="form-control form-control-alternative"
                  name="name"
                  rows="4"
                  cols="80"
                  placeholder="Type a message..."
                ></textarea>
              </base-input>
              <base-button type="default" round block size="lg">
                Send Message
              </base-button>
            </card>
          </div>
        </div>
      </div>
    </section> -->

    <div class="position-relative ">
      <div class="container pt-5" style="margin-top:100px">
        <div class="row ">
          <div class="col-md-12 text-center mb-5">
            <h1 class="display-1">Got a question?</h1>
            <h3 class="lead">We'd like to talk more about what you need</h3>
            <!-- <button class="btn btn-icon btn-primary mt-3" type="button">
                                <span class="btn-inner--icon"><i class="ni ni-chat-round"></i></span>
                                <span class="btn-inner--text">Chat with us</span>
                            </button> -->
          </div>
        </div>
        <div class="row contactus-3">
          <div class="col-lg-4 col-md-4 col-6 col-sm-12 col-border-cont ">
            <div class="info info-hover">
              <div
                class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
              >
                <i class="ni ni-square-pin"></i>
              </div>
              <h4 class="info-title">Address</h4>
              <p class="description px-0">
                201 Spear St, Suite 1100 <br />San Francisco, CA 94105
              </p>
              <p class="description px-0"></p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-6 col-sm-12 col-border-cont">
            <div class="info info-hover">
              <div
                class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
              >
                <i class="ni ni-email-83"></i>
              </div>
              <h4 class="info-title">Email</h4>
              <p class="description px-0">
                <a href="mailto:sales@universal-teck.com" target="_blank"
                  >sales@universal-teck.com</a
                >
              </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-4 col-6 col-sm-12">
            <div class="info info-hover">
              <div
                class="icon icon-shape icon-shape-primary icon-lg shadow rounded-circle text-primary"
              >
                <i class="ni ni-mobile-button"></i>
              </div>
              <h4 class="info-title">Phone</h4>
              <p class="description px-0">
                <a href="tel:1-888-886-4775">+1 (888) 886-4775</a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="main">
        <div class="container-fluid">
          <div class="row mt-2 mb-4 pt-5">
            <div class="col-md-7 ml-auto mr-auto text-center mt-5">
              <!-- <span class="badge badge-info">Leave a message</span> -->
              <h1 class="title">We would love to hear from you</h1>
              <h4 class="desc" style="line-height:2">
                If you have inquiries or want to learn more about Universal
                Tech, please contact us by completing the form below.
              </h4>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mx-auto ">
              <EmailForm></EmailForm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmailForm from "./components/EmailForm";
export default {
  name: "home",
  components: { EmailForm },
};
</script>
<style scoped>
.center_card {
  display: flex;
  flex-direction: column;
}
</style>
